import shallowEqual from 'shallowequal';
import { useAtomValue } from 'jotai';
import { selectAtom } from 'jotai/utils';
import { AgencySeller } from '../../types';
import { agencySellerAtom } from '../../atoms';

export const useAgencySellerData = <T>(selectSellerSlice: (seller: AgencySeller) => T): T =>
    useAtomValue(selectAtom(agencySellerAtom, selectSellerSlice, shallowEqual));
